import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/weixin.png'


const _withScopeId = n => (_pushScopeId("data-v-61a3fd7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "custom-left"
}
const _hoisted_2 = { class: "login-main" }
const _hoisted_3 = {
  key: 0,
  class: "firststep-container"
}
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = {
  key: 1,
  class: "logo-title"
}
const _hoisted_6 = { class: "login-mode" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "error-icon" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "close-icon" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "country-code" }, "+86", -1))
const _hoisted_12 = { class: "country-txt" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "country-code" }, "+852", -1))
const _hoisted_14 = { class: "country-txt" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "country-code" }, "+853", -1))
const _hoisted_16 = { class: "country-txt" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "country-code" }, "+65", -1))
const _hoisted_18 = { class: "country-txt" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "country-code" }, "+60", -1))
const _hoisted_20 = { class: "country-txt" }
const _hoisted_21 = {
  key: 1,
  class: "countdown"
}
const _hoisted_22 = {
  t: "1669711519501",
  style: {marginTop: '7px'},
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6936",
  width: "16",
  height: "16",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M943.254 375.558l-0.12-0.1c-17.357-14.294-42.775-11.232-56.859 6.295C798.229 491.322 663.174 561.584 512 561.584s-286.229-70.262-374.274-179.831c-14.084-17.527-39.502-20.589-56.859-6.295l-0.12 0.1c-16.76 13.801-19.687 38.642-6.122 55.594 43.269 54.077 96.432 99.831 156.62 134.821L170.943 689.61c-9.685 19.855-1.439 43.803 18.416 53.486h0.001c19.855 9.685 43.802 1.439 53.486-18.416l60.279-123.591c52.793 21.266 109.532 34.73 168.875 38.927v137.568c0 22.091 17.908 40 40 40s40-17.909 40-40V640.016c59.343-4.196 116.082-17.661 168.875-38.927l60.279 123.591c9.685 19.855 33.631 28.101 53.486 18.417 19.856-9.685 28.102-33.632 18.417-53.487l-60.302-123.637c60.188-34.99 113.352-80.744 156.62-134.821 13.565-16.953 10.639-41.794-6.121-55.594z",
  fill: "#afb9cd",
  "p-id": "6937"
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "remember-me"
}
const _hoisted_26 = {
  key: 0,
  class: "forget-text"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opt-split" }, null, -1))
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  key: 3,
  class: "other-login"
}
const _hoisted_30 = { class: "other-login-text" }
const _hoisted_31 = { class: "wechat-login-btn-container" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "微信",
  class: "wechat-icon"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "login-agreement" }
const _hoisted_35 = {
  key: 4,
  class: "agreement-message"
}
const _hoisted_36 = {
  key: 1,
  class: "firststep-container"
}
const _hoisted_37 = { class: "base-info-container" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "back-btn-text" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "info-container" }
const _hoisted_41 = { class: "setpwd" }
const _hoisted_42 = { class: "tips-text" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "error-icon" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "close-icon" }, null, -1))
const _hoisted_45 = { class: "password-tips" }
const _hoisted_46 = {
  key: 2,
  class: "firststep-container"
}
const _hoisted_47 = { class: "base-info-container" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "back-btn-text" }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "info-container" }
const _hoisted_51 = { class: "setpwd" }
const _hoisted_52 = { class: "tips-nickname-text" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "error-icon" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "close-icon" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-close-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-close-btn" })
], -1))
const _hoisted_56 = { class: "login-tips" }
const _hoisted_57 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginNav = _resolveComponent("LoginNav")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CloseCircleOutlined = _resolveComponent("CloseCircleOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_Inputpassword = _resolveComponent("Inputpassword")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["login-container", { 'transparent-container': _ctx.hideNav }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["login-box", { 'transparent-container': _ctx.hideNav, 'custom-login-box': _ctx.hideNav }])
    }, [
      (!_ctx.hideNav)
        ? (_openBlock(), _createBlock(_component_LoginNav, {
            key: 0,
            class: "nav"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1)),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.firstStep)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.logoMode == 'logo')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true),
              (_ctx.logoMode == 'text')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.logoTitle), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", {
                  class: _normalizeClass({ active: _ctx.loginMode === 2 }),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLoginMode(2)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.mimadenglu')) + " ", 1),
                  _hoisted_7
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass({ active: _ctx.loginMode === 1 }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLoginMode(1)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.yanzhengmadenglu')) + " ", 1),
                  _hoisted_8
                ], 2)
              ]),
              (_ctx.warningInfo.show)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 2,
                    closable: "",
                    showIcon: "",
                    type: "error",
                    message: _ctx.warningInfo.title,
                    class: "cbim-warning",
                    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.warningInfo.show = false))
                  }, {
                    icon: _withCtx(() => [
                      _hoisted_9
                    ]),
                    closeText: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["message"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form, {
                model: _ctx.formData,
                rules: _ctx.rules,
                ref: "loginForm",
                style: {"margin-top":"-20px"}
              }, {
                default: _withCtx(() => [
                  (_ctx.loginMode === 1)
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 0,
                        name: "phone",
                        style: {"margin-top":"18px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.phone,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.phone) = $event)),
                            placeholder: _ctx.$t('message.enterPhoneNumber'),
                            onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleClear(1))),
                            onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleFoucs(1))),
                            "aria-autocomplete": "list",
                            autocomplete: "off"
                          }, {
                            addonBefore: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: _ctx.formData.countryCode,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.countryCode) = $event)),
                                style: {"width":"90px"},
                                dropdownMatchSelectWidth: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select_option, { value: "+86" }, {
                                    default: _withCtx(() => [
                                      _hoisted_11,
                                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('message.code86')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "+852" }, {
                                    default: _withCtx(() => [
                                      _hoisted_13,
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.code852')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "+853" }, {
                                    default: _withCtx(() => [
                                      _hoisted_15,
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.code853')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "+65" }, {
                                    default: _withCtx(() => [
                                      _hoisted_17,
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('message.code65')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: "+60" }, {
                                    default: _withCtx(() => [
                                      _hoisted_19,
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('message.code60')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            suffix: _withCtx(() => [
                              _createElementVNode("span", null, [
                                (_ctx.formData.phone !== '' && _ctx.phoneClose)
                                  ? (_openBlock(), _createBlock(_component_CloseCircleOutlined, {
                                      key: 0,
                                      onMousedown: _withModifiers(_ctx.handleChange, ["prevent"]),
                                      style: {color: '#afb9cd'}
                                    }, null, 8, ["onMousedown"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 1,
                        name: "mobile",
                        ref: "name",
                        style: {"margin-top":"18px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.mobile,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                            placeholder: _ctx.$t('message.enterPhoneNumberOrEmail'),
                            onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleClear(2))),
                            onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleFoucs(2))),
                            "aria-autocomplete": "list",
                            autocomplete: "off"
                          }, {
                            suffix: _withCtx(() => [
                              _createElementVNode("span", null, [
                                (_ctx.formData.mobile !== '' && _ctx.mobileClose)
                                  ? (_openBlock(), _createBlock(_component_CloseCircleOutlined, {
                                      key: 0,
                                      onMousedown: _withModifiers(_ctx.handleChange, ["prevent"]),
                                      style: {color: '#afb9cd'}
                                    }, null, 8, ["onMousedown"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }, 512)),
                  (_ctx.loginMode === 1)
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 2,
                        class: "authcode",
                        name: "authCode",
                        style: {"margin-top":"18px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.authCode,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.authCode) = $event)),
                            valueModifiers: { number: true },
                            placeholder: _ctx.$t('message.fouryanzhengma')
                          }, {
                            suffix: _withCtx(() => [
                              (!_ctx.hasSend)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["v-code", { 'is-disabled': (_ctx.isCanSend && !_ctx.isValidatePhonePass) || !_ctx.isCanSend }]),
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleClickSendVerifyCode && _ctx.handleClickSendVerifyCode(...args)))
                                  }, _toDisplayString(_ctx.verifyCodeTitle), 3))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('message.houkechongfaqian')) + _toDisplayString(`${_ctx.countdown}s`) + _toDisplayString(_ctx.$t('message.houkechongfahou')), 1))
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 3,
                        class: "password",
                        name: "password",
                        style: {"margin-top":"18px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.password,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.password) = $event)),
                            placeholder: _ctx.$t('message.qingshurumima'),
                            autocomplete: "new-password",
                            type: _ctx.pwdtype,
                            onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.handleClickLogin()), ["enter"]))
                          }, {
                            suffix: _withCtx(() => [
                              _createElementVNode("span", null, [
                                (_ctx.pwdtype === 'password')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      onMousedown: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.handleChangePwdtype('text')), ["prevent"])),
                                      style: {color: '#afb9cd'}
                                    }, [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
                                    ], 32))
                                  : _createCommentVNode("", true),
                                (_ctx.pwdtype === 'text')
                                  ? (_openBlock(), _createBlock(_component_EyeOutlined, {
                                      key: 1,
                                      onMousedown: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.handleChangePwdtype('password')), ["prevent"])),
                                      style: {color: '#afb9cd', fontSize: '16px'}
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder", "type"])
                        ]),
                        _: 1
                      })),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        class: _normalizeClass(["login-btn", { 'is-disabled-btn': !_ctx.isCanClick }]),
                        loading: _ctx.loading,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleClickLogin()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.login')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "class"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createElementVNode("div", {
                class: "no-account",
                style: _normalizeStyle({fontSize: _ctx.currentLanguage === 'en' ? '14px' : '16px'})
              }, [
                (_ctx.loginMode === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_a_checkbox, {
                        class: "checkbox-text checkbox-16",
                        checked: _ctx.formData.rememberMe,
                        "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.rememberMe) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.jizhumima')), 1)
                        ]),
                        _: 1
                      }, 8, ["checked"]),
                      (!_ctx.hideNav)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.forgetPassword())),
                              class: "link",
                              style: {"float":"right"}
                            }, _toDisplayString(_ctx.$t('message.wangjimima')), 1),
                            _hoisted_27
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideNav)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.register())),
                        class: "link"
                      }, _toDisplayString(_ctx.$t('message.zhuce')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 4),
              (!_ctx.hideNav)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('message.qitalogin')), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", {
                        class: "wechat-login-btn",
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.goToWechatAuth && _ctx.goToWechatAuth(...args)))
                      }, _hoisted_33)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_a_checkbox, {
                  checked: _ctx.checked,
                  "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.checked) = $event)),
                  class: "checkbox-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.yuedutongyi')) + " ", 1),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleAgreement())),
                      class: "login-agreement-doc"
                    }, _toDisplayString(_ctx.$t('message.yonghufuwuxieyi')) + _toDisplayString(_ctx.$t('message.dunhao')) + _toDisplayString(_ctx.$t('message.yinsixieyi')), 1)
                  ]),
                  _: 1
                }, 8, ["checked"])
              ]),
              (_ctx.agreementTips)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t('message.gouxuantongyixieyi')), 1))
                : _createCommentVNode("", true)
            ]))
          : (!_ctx.firstStep && _ctx.noPwd)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", {
                    class: "back-btn",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.backFirstSetp && _ctx.backFirstSetp(...args)))
                  }, _hoisted_39),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('message.shezhimima')), 1),
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('message.weilezhanghaoanquan')) + " " + _toDisplayString(`${_ctx.userMobile}`) + " " + _toDisplayString(_ctx.$t('message.shezhimimajuhao')), 1)
                  ])
                ]),
                (_ctx.warningInfo.show)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      closable: "",
                      showIcon: "",
                      type: "error",
                      message: _ctx.warningInfo.title,
                      class: "cbim-warning",
                      onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.warningInfo.show = false))
                    }, {
                      icon: _withCtx(() => [
                        _hoisted_43
                      ]),
                      closeText: _withCtx(() => [
                        _hoisted_44
                      ]),
                      _: 1
                    }, 8, ["message"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form, {
                  model: _ctx.formData,
                  rules: _ctx.rules,
                  ref: "setpwdForm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { name: "newpassword" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_popover, {
                          ref: "popover",
                          placement: "right",
                          width: 160,
                          trigger: "click"
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_45, [
                              _createElementVNode("li", {
                                class: _normalizeClass(["password-tips-text", { 'password-tips-text-checked': _ctx.isOverSix }])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["cbim-icon", { 'cbim-icon-check': _ctx.isOverSix }])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.zhishao')) + _toDisplayString(_ctx.passwordMin) + _toDisplayString(_ctx.$t('message.zhishaoweishu')), 1)
                              ], 2),
                              _createElementVNode("li", {
                                class: _normalizeClass(["password-tips-text", { 'password-tips-text-checked': _ctx.isLessMax }])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["cbim-icon", { 'cbim-icon-check': _ctx.isLessMax }])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.zhiduo')) + _toDisplayString(_ctx.passwordMax) + _toDisplayString(_ctx.$t('message.zhishaoweishu')), 1)
                              ], 2),
                              _createElementVNode("li", {
                                class: _normalizeClass(["password-tips-text", { 'password-tips-text-checked': _ctx.hasNumber }])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["cbim-icon", { 'cbim-icon-check': _ctx.hasNumber }])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.baohanshuzi')), 1)
                              ], 2),
                              _createElementVNode("li", {
                                class: _normalizeClass(["password-tips-text", { 'password-tips-text-checked': _ctx.hasBigLittleLetter }])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["cbim-icon", { 'cbim-icon-check': _ctx.hasBigLittleLetter }])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.baohandaxiaoxiezimu')), 1)
                              ], 2),
                              _createElementVNode("li", {
                                class: _normalizeClass(["password-tips-text", { 'password-tips-text-checked': _ctx.hasSpecialSymbol }])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(["cbim-icon", { 'cbim-icon-check': _ctx.hasSpecialSymbol }])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('message.baohanteshuzifu')), 1)
                              ], 2)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Inputpassword, {
                              value: _ctx.formData.newpassword,
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.newpassword) = $event)),
                              placeholder: _ctx.$t('message.qingshurumima')
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, { name: "secpassword" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Inputpassword, {
                          value: _ctx.formData.secpassword,
                          "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.secpassword) = $event)),
                          placeholder: _ctx.$t('message.zaicishurumima')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          class: _normalizeClass(["login-btn", { 'is-disabled-btn': !_ctx.isCanClick }]),
                          loading: _ctx.loading,
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.firstSetpwd()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.login')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading", "class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]))
            : (!_ctx.firstStep && _ctx.noName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", {
                      class: "back-btn",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.backFirstSetp('setName')))
                    }, _hoisted_49),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('message.shezhinicheng')), 1),
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('message.gaizenmechenghunin')), 1)
                    ])
                  ]),
                  (_ctx.warningInfo.show)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 0,
                        closable: "",
                        showIcon: "",
                        type: "error",
                        message: _ctx.warningInfo.title,
                        class: "cbim-warning",
                        onClose: _cache[29] || (_cache[29] = ($event: any) => (_ctx.warningInfo.show = false))
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_53
                        ]),
                        closeText: _withCtx(() => [
                          _hoisted_54
                        ]),
                        _: 1
                      }, 8, ["message"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_form, {
                    model: _ctx.formData,
                    rules: _ctx.rules,
                    ref: "setpwdForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { name: "name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.formData.name,
                            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.name) = $event)),
                            placeholder: _ctx.$t('message.qingshuruxingming'),
                            onBlur: _cache[31] || (_cache[31] = ($event: any) => (_ctx.handleClear(2))),
                            onFocus: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleFoucs(2))),
                            "aria-autocomplete": "list",
                            autocomplete: "off"
                          }, {
                            suffix: _withCtx(() => [
                              _createElementVNode("span", null, [
                                (_ctx.formData.mobile !== '' && _ctx.mobileClose)
                                  ? (_openBlock(), _createBlock(_component_CloseCircleOutlined, {
                                      key: 0,
                                      onMousedown: _withModifiers(_ctx.handleChange, ["prevent"]),
                                      style: {color: '#afb9cd'}
                                    }, null, 8, ["onMousedown"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }, 8, ["value", "placeholder"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: _normalizeClass(["login-btn", { 'is-disabled-btn': !_ctx.isCanClick }]),
                            loading: _ctx.loading,
                            onClick: _ctx.firstSetname
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.login')), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "class", "onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]))
              : _createCommentVNode("", true),
        _createVNode(_component_a_modal, {
          title: _ctx.$t('message.denglutixing'),
          visible: _ctx.hasLogin,
          "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.hasLogin) = $event)),
          class: _normalizeClass({'modal-conteiner': _ctx.hideNav}),
          "custom-class": "cbim-dialog",
          width: "408px",
          "append-to-body": "",
          centered: "",
          mask: false,
          maskClosable: false
        }, {
          closeIcon: _withCtx(() => [
            _hoisted_55
          ]),
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_57, [
              _createVNode(_component_a_button, {
                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.hasLogin = false)),
                class: "cbim-button-samll",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.quxiao')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.continueLogin,
                class: "cbim-button-samll",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.jixudenglu')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('message.yizaiqitadifangdenglu')), 1)
          ]),
          _: 1
        }, 8, ["title", "visible", "class"])
      ])
    ], 2)
  ], 2))
}